/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Noversionsfound2Inputs */

const zh_publish_noversionsfound2 = /** @type {(inputs: Publish_Noversionsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到版本`)
};

const en_publish_noversionsfound2 = /** @type {(inputs: Publish_Noversionsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No versions found`)
};

const es_publish_noversionsfound2 = /** @type {(inputs: Publish_Noversionsfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron versiones`)
};

/**
* | output |
* | --- |
* | "No versions found" |
*
* @param {Publish_Noversionsfound2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const publish_noversionsfound2 = /** @type {((inputs?: Publish_Noversionsfound2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Noversionsfound2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_noversionsfound2(inputs)
	if (locale === "en") return en_publish_noversionsfound2(inputs)
	return es_publish_noversionsfound2(inputs)
});
export { publish_noversionsfound2 as "publish_noVersionsFound" }